import RemoveProductModal from "./RemoveProductModal";

export default RemoveProductModal;
